/* eslint class-methods-use-this: 0 */
import { MeRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Recaptcha from 'services/recaptcha';

const _serviceDependencies = ['$rootScope', '$scope', '$state', 'Util', 'Auth', 'OAuthRestService', 'GdprActionsRestService'];

let _$rootScope;
let _$scope;
let _Util;
let _Auth;
let _User;
let _OAuthRestService;
let _oauthPayload = {};
let _verifyIdentity;
let _formIsValid = null;
let _$state;

/**
 * @ngdoc service
 * @name controllers.PasswordConfirmationModal
 *
 * @description
 * Crop Image controller
 */
class PasswordConfirmationModal {

    /**
     * @param  {any} $rootScope
     * @param  {any} $scope
     * @param  {any} $window
     * @param  {any} Util
     * @param  {any} Auth
     * @param  {any} Recaptcha
     * @param  {any} OAuthRestService
     */
    constructor(
        $rootScope, $scope, $state, Util, Auth,
        OAuthRestService,
    ) {

        _Util = Util;
        _Auth = Auth;
        _OAuthRestService = OAuthRestService;
        _User = MeRepository.getMyUser();
        _$scope = $scope;
        _$rootScope = $rootScope;
        _verifyIdentity = this.verifyIdentity;
        _$state = $state;

        // functions
        _$scope.nextModal = this.nextModal;
        _$scope.closeModal = this.closeModal;
        _$scope.onSubmit = this.onSubmit;
        _$scope.setEmail = this.setEmail;
        _$scope.setCaptchaResponse = this.setCaptchaResponse;

        // variables
        _$scope.captchaRequired = false;
        _$scope.authError = false;
        _$scope.loading = false;
        _$scope.loadingConfirm = false;
        _$scope.failedLogins = 0;
        _$scope.Recaptcha = Recaptcha;
        _$scope.modalStylingClasses = {};
        _$scope.Auth = Auth;

        if (_$rootScope.passwordComnfirmationFor === 'delete-account-confirmation') {

            _$scope.modalStylingClasses = {
                titleColor: 'text-grey-2 mb30',
                titleKey: 'cw.validator.password.error.enter_password',
                btnColor: '',
            };

        }

    }

    nextModal() {

        _$state.go('root.dashboard.my-account.ltb', {
            ltb: _$rootScope.passwordComnfirmationFor,
        });

    }

    closeModal() {

        _Util.closeModal();

    }
    verifyIdentity() {

        _$scope.submitted = true;

        _oauthPayload = {
            grant_type: 'password',
            username: _User.attributes.email,
            password: this.verifyIdentityForm.password.$viewValue,
        };

        const headers = {
            Authorization: `Basic ${_Util.base64encode(CWCONFIG.oauthKey)}`,
        };

        const captchaRespose = _$scope.Recaptcha.getCaptchaResponse();

        if (captchaRespose) {

            headers['X-Avira-Captcha-Token'] = captchaRespose;

        }

        const deviceToken = _Auth.getDeviceToken();
        if (deviceToken) {

            _oauthPayload.device_token = deviceToken;

        }

        /* if captcha is required and there is no captcha response available,
               trigger alert and stop login process */
        if (_$scope.captchaRequired && !_$scope.captchaRespose) {

            _Util.triggerAnimation('#error-message-captcha', 'animated shake');
            return;

        }

        if (_formIsValid) {

            _$scope.loading = true;

            _OAuthRestService
                .post(_oauthPayload, headers)
                .then(() => {

                    _$scope.nextModal();
                    _$scope.loading = false;
                    _$scope.failedLogins = 0;
                    _$scope.Recaptcha.disableCaptcha();
                    _$rootScope.kp = this.verifyIdentityForm.password.$viewValue;

                })
                .then(null, (error) => {

                    const responseError = _Util.deepFind(error, 'data.error');
                    _$scope.loading = false;
                    _$scope.failedLogins += 1;

                    switch (responseError) {

                    case 'invalid_credentials':

                        _$scope.authError = true;

                        _Util.triggerAnimation('#error-message-form', 'animated shake');

                        // check error header for captcha required

                        if (error.headers('X-Avira-Captcha') === 'required') {

                            _$scope.Recaptcha.enableCaptcha();

                        }

                        break;

                    case 'required_captcha':

                        _$scope.Recaptcha.execute();
                        break;

                    case 'retries_exceeded':

                        Alert.error('cw.auth.tfa.error.retries_exceeded');
                        break;

                    case 'invalid_otp':

                        _$scope.nextModal();
                        _$rootScope.kp = this.verifyIdentityForm.password.$viewValue;

                        break;

                    default:

                        Alert.error('cw.notification.system.error');

                    }

                });

        } else {

            _Util.triggerAnimation('.error', 'animated shake');

        }

    }
    onSubmit() {

        _formIsValid = this.verifyIdentityForm.$valid;

        if (_$scope.Recaptcha.captchaRetries <= _$scope.failedLogins) {

            _$scope.Recaptcha.enableCaptcha();

        }

        if (_$scope.Recaptcha.isCaptchaRequired()) {

            _$scope.Recaptcha.execute();

        } else {

            _formIsValid = this.verifyIdentityForm.$valid;
            const _verifyIdentityBind = _verifyIdentity.bind(this);
            _verifyIdentityBind();

        }

    }

    setCaptchaResponse(response) {

        _formIsValid = this.verifyIdentityForm.$valid;
        _$scope.Recaptcha.setCaptchaResponse(response);
        const _verifyIdentityBind = _verifyIdentity.bind(this);
        _verifyIdentityBind();

    }

    setEmail() {

        _$rootScope.forgotEmail = _User.attributes.email;

    }

}

_serviceDependencies.push(PasswordConfirmationModal);

angular.module('controllers')
    .controller('PasswordConfirmationModal', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/my-account/password-confirmation/password-confirmation.js